export default "__VITE_ASSET__C4KMQ4Ou__"